import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import Clock from 'react-live-clock';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import '../../../styles/workSchedule.scss';
import { IInfoScreenColorsForm } from '../../administration/organization/generalSettings/design/GeneralSettingsDesignInfoScreen';
import { IOrganizationSchedule, IScheduleRowColumn } from './models';

interface IProps {
    isVertical: boolean;
    design: IInfoScreenColorsForm;
    schedules: IOrganizationSchedule[];
}

const ScheduleSlider: FC<IProps> = (props) => {
    const [slider, setSlider] = useState<Slider | null>(null);
    const [currentSlideIndex, setCurrentSlideIndex] = useState<number>(0);

    const countSlide = (): number => {
        if (props.schedules && props.schedules.length !== 1 && props.schedules.length - 1 > currentSlideIndex) {
            return currentSlideIndex + 1;
        }
        return 0;
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (moment().seconds() % 20 === 0 && slider !== null) {
                slider.slickNext();
                setCurrentSlideIndex(countSlide());
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [slider, currentSlideIndex]);

    const settings: Settings = {
        accessibility: false,
        arrows: false,
        dots: false,
        draggable: false,
        infinite: true,
        pauseOnHover: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        useCSS: true
    };

    return (
        <>
            <div className="scheduleHeader" style={{ color: props.design.textColor?.toString() }}>
                {props.schedules && props.schedules[currentSlideIndex] && props.schedules[currentSlideIndex].isWorkScheduleTitleShown && (
                    <div className={`scheduleHeaderTitleColumn ${props.isVertical && `scheduleHeaderTitleColumn-vertical`}`}>
                        {props.schedules[currentSlideIndex].workScheduleTitleName}
                    </div>
                )}
                {!props.isVertical && (
                    <div className={`scheduleHeaderDateAndTimeColumn ${props.isVertical && `scheduleHeaderDateAndTimeColumn-vertical`}`}>
                        <div>
                            {moment().format('MM DD')}
                            <span style={{ paddingLeft: '20px' }}>
                                <Clock format={'HH:mm'} ticking={true} timezone={moment().zoneAbbr()} />
                            </span>
                        </div>
                    </div>
                )}
            </div>
            <div className="scheduleContent">
                <Slider ref={(c) => setSlider(c)} {...settings}>
                    {props.schedules.map((x: IOrganizationSchedule, xIndex: number) => {
                        return (
                            <div key={xIndex}>
                                {x.scheduleRows.map((z, zIndex) => {
                                    return (
                                        <div
                                            key={`${xIndex} ${zIndex} 0`}
                                            className="wrapper"
                                            style={{
                                                backgroundColor: props.design.textColor?.toString(),
                                                color: props.design.secondaryColor?.toString()
                                            }}
                                        >
                                            <div
                                                key={`${xIndex} ${zIndex} 1`}
                                                className={`left ${props.isVertical && `left-vertical`} workplaceNumber ${
                                                    props.isVertical && `workplaceNumber-vertical`
                                                }`}
                                                style={{
                                                    color: props.design.textColor?.toString(),
                                                    backgroundColor:
                                                        !z.workplaceNumber || z.workplaceNumber === ''
                                                            ? props.design.textColor?.toString()
                                                            : props.design.secondaryColor?.toString()
                                                }}
                                            >
                                                {z.workplaceNumber}
                                            </div>

                                            {z.scheduleRowColumns.map((y: IScheduleRowColumn, yIndex: number) => {
                                                return (
                                                    <div
                                                        className={`right ${props.isVertical && `right-vertical`} scheduleRow`}
                                                        style={{
                                                            backgroundColor: props.design.textColor?.toString()
                                                        }}
                                                        key={`${xIndex} ${zIndex} ${yIndex}`}
                                                    >
                                                        {yIndex % 2 !== 0 && (
                                                            <div id="sectionWrap" className="middleCol">
                                                                <img
                                                                    className={`dividerImg ${props.isVertical && `dividerImg-vertical`}`}
                                                                    src={process.env.PUBLIC_URL + '/img/scheduleDivider.png'}
                                                                />
                                                            </div>
                                                        )}

                                                        <div
                                                            id="sectionWrap"
                                                            className={`${yIndex % 2 === 0 ? `firstCol` : `secondCol`}
                                                                ${z.scheduleRowColumns.length - yIndex > 2 && `practitionerInfoRowDivider`}`}
                                                        >
                                                            <div className="section-main">
                                                                <div style={{ fontWeight: 'bold', wordWrap: 'break-word' }}>
                                                                    {y.firstName !== null && y.firstName} {y.lastName !== null && y.lastName}
                                                                </div>
                                                                <div className="break" />
                                                                {y.qualification}
                                                            </div>
                                                            <div className={`section-secondary  ${props.isVertical && `section-secondary-vertical`}`}>
                                                                {y.statusText}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </>
    );
};

export default ScheduleSlider;
